import axios from 'axios';
import { WhiteLabelIds } from '@agoda/layout';
import { getBootstrapConfig } from 'core/window/windowService';
import { origin as getOrigin, href, reload, setHref } from 'core-framework/window/location';
import { logError, logInfo } from 'core-framework/util/LogMessage';

export const logoutWithUnifiedLoginApi = (ssoLogoutUrl: string, isMockData: boolean) => {
    const origin = isMockData ? 'http://hk-ulqa-2001.agoda.local:9000' : getOrigin();
    const queryParams = `?tr_returnUrl=${encodeURIComponent(href())}`;
    setHref(`${origin}${ssoLogoutUrl}${queryParams}`);
};

export const logoutWithCronos = async (pageTypeId: number, whiteLabelId: WhiteLabelIds): Promise<boolean> => {
    try {
        logInfo(`Initiate logout using Cronos logout API for Whitelabel ${whiteLabelId}`, pageTypeId);
        const response = await axios('/api/cronos/main/logout', { method: 'POST' });
        if (!response || response.status !== 200) {
            logError(`logout-error, result: ${response.status}, Whitelabel ${whiteLabelId}`, pageTypeId);
        }
        logInfo(`logout-success, result: ${response.data}, Whitelabel ${whiteLabelId}`, pageTypeId);
        reload();
    } catch (error) {
        logError(`logout-error, result: ${error}, Whitelabel ${whiteLabelId}`, pageTypeId);
    }
    return true;
};

export const logout = (pageTypeId: number, whiteLabelId: WhiteLabelIds, config = getBootstrapConfig()): Promise<boolean> | undefined => {
    if (config?.behavior?.common?.isLogoutWithCronosEnabled) {
        return logoutWithCronos(pageTypeId, whiteLabelId);
    }

    if (!config?.partner?.ssoLogoutUrl) {
        throw Error(`Can not logout for whitelabel ${whiteLabelId}. logoutUrl is not defined in PartnerSsoService.`);
    }
    logoutWithUnifiedLoginApi(config.partner.ssoLogoutUrl, config.isMockData);
    return undefined;
};
